// Дата пробного (за Києвом, "YYYY-MM-DD"). Пробний — разовий урок: у записі «день тижня + час» (classSchedule),
// а з 11.2026 бекенд ще й зберігає lessonDate — найближчий такий день від моменту створення/перенесення (та сама логіка, що тут).
// Для старих записів без lessonDate рахуємо від дати створення.

export const weekDays = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];
const dayLong = ["понеділок", "вівторок", "середа", "четвер", "пʼятниця", "субота", "неділя"];
const months = ["січня", "лютого", "березня", "квітня", "травня", "червня", "липня", "серпня", "вересня", "жовтня", "листопада", "грудня"];
export const DAY = 86400000;

export const kyivParts = (date) => {
  const parts = Object.fromEntries(
    new Intl.DateTimeFormat("en-GB", {
      timeZone: "Europe/Kyiv", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23",
    }).formatToParts(date).map(({ type, value }) => [type, value])
  );
  return { ymd: `${parts.year}-${parts.month}-${parts.day}`, hm: `${parts.hour}:${parts.minute}` };
};

// Дати рахуємо як опівніч UTC — так додавання днів не ламається на переході часу
export const ymdToDate = (ymd) => new Date(`${ymd}T00:00:00Z`);
export const dateToYmd = (date) => date.toISOString().slice(0, 10);
export const weekIndex = (date) => (date.getUTCDay() + 6) % 7; // 0 = понеділок
export const shortDate = (date) => `${date.getUTCDate()} ${months[date.getUTCMonth()]}`;
export const longDate = (ymd) => `${dayLong[weekIndex(ymdToDate(ymd))]}, ${shortDate(ymdToDate(ymd))}`;

// Найближчий day (monday…) від моменту from; якщо це сьогодні, а час уже минув — через тиждень
export const nextTrialDate = (day, time, from = new Date()) => {
  const target = weekDays.indexOf(String(day).toLowerCase());
  if (target < 0 || !from) return null;
  const now = kyivParts(new Date(from));
  const base = ymdToDate(now.ymd);
  let shift = (target - weekIndex(base) + 7) % 7;
  if (shift === 0 && time && time.padStart(5, "0") < now.hm) shift = 7;
  return dateToYmd(new Date(base.getTime() + shift * DAY));
};

export const trialDateOf = (lesson, slot = lesson.classSchedule?.[0]) =>
  (/^\d{4}-\d{2}-\d{2}$/.test(lesson.lessonDate || "") && lesson.lessonDate) ||
  (slot ? nextTrialDate(slot.day, slot.time, lesson.createdAt) : null);
